<template>
  <footer id="footer" class="footer bg-neutral">
    <div class="container">
      <div class="row">

        <div class="col-lg-6"><h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3><h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4></div>
        <div class="col-4 text-lg-center btn-wrapper">
          <a
            target="_blank"
            href="https://www.linkedin.com/company/umbairealities/"
            class="btn btn-neutral btn-icon-only btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fa fa-linkedin"></i>
          </a>
          <a
            target="_blank"
            href="https://www.facebook.com/umbai.co.za"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Like us"
          >
            <i class="fa fa-facebook-square"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{year}}
            Umbai all rights reserved
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Terms" class="nav-link">Terms</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Privacy" class="nav-link">Privacy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>


